import { PropsWithChildren } from 'react';

import styles from './WizardLayout.module.scss';

type WizardLayoutProps = PropsWithChildren;

export const WizardLayout = ({ children }: WizardLayoutProps) => {
  return <div className={styles.wizardLayout}>{children}</div>;
};
